module.exports = __webpack_public_path__ + "img/settings.d7f47a7e.png";